
import VueSlickCarousel from 'vue-slick-carousel'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'DealsSlider',
  components: {
    VueSlickCarousel,
  },
  setup () {
    const carousel = ref<any>(null)
    return {
      carousel,
    }
  },
})
